import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { guideCards } from '../data/content';
export function TomosSection() {
  return <section className="w-full bg-cream px-5 py-12 sm:py-20" data-id="element-269" data-mp="1p4lk39ey7pry">
      <div className="mx-auto max-w-5xl" data-id="element-270" data-mp="1u2dkysxkmm8a">
        <div className="grid items-center gap-8 md:grid-cols-2 md:gap-12" data-id="element-271" data-mp="1u1by7r770baq">
          <figure className="order-1 mx-auto w-full max-w-[420px] md:order-none md:max-w-none" data-id="element-272" data-mp="xd5xhfde631q">
            <div className="relative overflow-hidden rounded-[26px] bg-plum p-1.5 shadow-[0_26px_60px_-28px_rgba(52,36,60,0.55)] ring-1 ring-gold/25 sm:p-2" data-id="element-273" data-mp="11d7omuli3e2r">
              <div className="relative overflow-hidden rounded-[20px]" data-id="element-274" data-mp="16ff6g0t0hod0">
                <img src="https://cdn.magicpatterns.com/uploads/3cTnh7TtWpa5xDhfFf4jWB/Aura-Viva-guia-autocuracion-mockup.webp" alt="Guía de Autocuración Energética abierta junto a sus páginas interiores y tarjetas de práctica" width="779" height="1000" loading="lazy" decoding="async" sizes="(max-width: 768px) calc(100vw - 40px), 420px" className="block aspect-[4/5] w-full object-cover" data-id="element-275" data-mp="1bdqeq73nrqt4" />
                <div className="pointer-events-none absolute inset-0 rounded-[20px] shadow-[inset_0_0_46px_16px_rgba(52,36,60,0.6)]" aria-hidden="true" data-id="element-276" data-mp="2copmbktihzkl" />
                <div className="pointer-events-none absolute inset-0 rounded-[20px] ring-1 ring-inset ring-gold/15" aria-hidden="true" data-id="element-277" data-mp="22y4gbcbidsrn" />
              </div>
            </div>
          </figure>

          <div className="order-2 text-center md:order-none md:text-left" data-id="element-278" data-mp="1tzsudnll7j5j">
            <span className="mb-5 inline-block rounded-full border border-gold/50 bg-gold/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-plum" data-id="element-279" data-mp="1oxtpuae42g70">
              El corazón del sistema
            </span>
            <h2 className="font-serif-display text-2xl font-bold leading-tight text-plum sm:text-4xl" data-id="element-280" data-mp="1aauzkiqzprtv">
              Guía de Autocuración Energética
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-plum/75 sm:text-base" data-id="element-281" data-mp="11c9i6qx98iuo">
              Una guía visual de 48 páginas para comprender cómo se relacionan tus emociones, tu
              energía y tu bienestar, y comenzar con prácticas sencillas que puedas incorporar a tu
              vida cotidiana.
            </p>
            <div className="mx-auto mt-5 h-px w-16 bg-gold/60 md:mx-0" data-id="element-282" data-mp="1y18xgpw9akwd" />
            <p className="mt-5 text-sm leading-relaxed text-plum/75 sm:text-base" data-id="element-283" data-mp="1k9asmr9kvb60">
              Esta guía fue creada para ayudarte a detenerte, observar qué estás atravesando y
              elegir conscientemente una herramienta de autocuidado.
            </p>
            <p className="mt-3 text-sm leading-relaxed text-plum/75 sm:text-base" data-id="element-284" data-mp="2gs8ff75c2ug5">
              No necesitás tener conocimientos previos ni seguir una rutina perfecta. Podés avanzar
              a tu ritmo, volver a una sección cuando lo necesites y comenzar por la práctica que
              más conecte con tu momento actual.
            </p>
          </div>
        </div>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-285" data-mp="f55ifny7qrvp">
          {guideCards.map((card, i) => <motion.article key={card.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: i % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex h-full flex-col rounded-2xl border border-aura/15 bg-card p-6" data-id="element-286" data-mp="3ijt7076pkk4a" data-mpi={i}>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-aura/10 text-aura" data-id="element-287" data-mp="17rhwivenlwnj">
                <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-288" data-mp="12t6mokoczm5b" />
              </span>
              <h3 className="mt-4 text-base font-bold leading-snug text-plum sm:text-lg" data-id="element-289" data-mp="38h7cs291gfby">
                {card.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-plum/75" data-id="element-290" data-mp="3dgtqecss3xla">{card.description}</p>
            </motion.article>)}
        </div>

        <div className="mt-8 flex justify-center" data-id="element-291" data-mp="3mggrexhlj1dt">
          <span className="inline-flex items-center gap-2 rounded-full border border-gold/50 bg-card px-5 py-2.5 text-center text-sm font-medium text-plum" data-id="element-292" data-mp="3mi9y2cs7lllt">
            <SparklesIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-293" data-mp="8ywg8pjmpcm" />
            48 páginas de orientación, prácticas y herramientas de autocuidado energético.
          </span>
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center text-base leading-relaxed text-plum sm:text-lg" data-id="element-294" data-mp="9227kacpuq43">
          No se trata de buscar una solución perfecta. Se trata de aprender a escucharte y{' '}
          <span className="font-semibold text-aura" data-id="element-295" data-mp="iz6zkqt8tfst">comenzar por una acción posible</span>.
        </p>

        <div className="mx-auto mt-8 w-full max-w-md" data-id="element-296" data-mp="t4yej6p83ghe">
          <CTAButton label="QUIERO ACCEDER A LA GUÍA COMPLETA" textClassName="text-[13px] tracking-tight sm:text-[16px] sm:tracking-normal" data-id="element-297" data-mp="t1kei5417jd4" />
          <p className="mt-3 text-center text-xs text-plum/60 sm:text-sm" data-id="element-298" data-mp="j60sqbj6m123">
            Incluida dentro de Aura Viva 2026 · Acceso digital inmediato
          </p>
        </div>
      </div>
    </section>;
}